<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div v-if="content.length > 0">
          <h3 class="card-title"><i class="ti ti-files"></i> {{ $t("Added content") }}</h3>
          <div v-for="item in content" class="card-text" >
            <vue-markdown>{{ item.content }}</vue-markdown>
          </div>
          <hr v-if="attachments.length > 0">
        </div>
        <div v-if="attachments.length > 0">
          <h5 class="card-title">{{ $t("Attachements") }}</h5>
          <div v-for="item in attachments">
            <!-- TODO: test.achiev.eu weghalen -->
            <span class="btn btn-secondary btn-sm btn-rounded m-b-10" v-if="item.attachment !== null"><i class="ti ti-file"></i>
              <a :href="url + item.attachment_url" target="_blank"> {{ item.attachment }}</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["contentData"],
    name: "content-widget",
    data: function () {
      return {
        contentDataItems: {},
        content: [],
        attachments: [],
        url: window.location.origin
      }
    },
    created(){
      let contentDataItems = this.contentData;
      for (let i = 0; i < contentDataItems.length; i++) {
        let contentItem = contentDataItems[i];
        if(contentItem.content !== null){
          this.content.push(contentItem);
        }

        if(contentItem.attachment !== null){
          this.attachments.push(contentItem);
        }

      }
    }
  }
</script>

<style scoped>
  p.card-text{
    margin-top: 20px;
  }
  img{
    max-width: 100%;
  }

  .card-title > .ti-files{
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ContentWidget.vue